/**
 * Format a price value as USD currency (2 decimal places).
 * Handles string or null input gracefully.
 *
 * Returns null if the price is null/undefined so the caller
 * can show a "Call for price" fallback.
 */
export function formatCurrency(price: string | number | null | undefined): string | null {
	if (price == null) return null;

	const numeric = typeof price === 'number' ? price : parseFloat(price);

	if (isNaN(numeric)) return null;

	return numeric.toLocaleString('en-US', {
		style: 'currency',
		currency: 'USD',
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
}
